// ============================================
// Audio Hook for TTS Playback
// ============================================

import { useCallback } from 'preact/hooks';
import { audioService } from '@/services';
import { audioPlaying, audioLoading, showNotification } from '@/state/signals';

export function useAudio() {
  const playAudio = useCallback(async (text: string, buttonElement?: HTMLElement) => {
    if (audioLoading.value || audioPlaying.value) return;

    audioLoading.value = true;

    try {
      await audioService.playAudio(text, {
        buttonElement,
        onStart: () => {
          audioLoading.value = false;
          audioPlaying.value = true;
        },
        onEnd: () => {
          audioPlaying.value = false;
        },
        onError: (error) => {
          audioPlaying.value = false;
          audioLoading.value = false;
          console.error('Audio playback error:', error);
          showNotification('Audio temporarily unavailable', 'error');
        }
      });
    } catch (error) {
      audioLoading.value = false;
      audioPlaying.value = false;

      if (audioService.isAvailable()) {
        showNotification('Failed to play audio', 'error');
      } else {
        showNotification('Audio service unavailable. Try again later.', 'warning');
      }
    }
  }, []);

  const stopAudio = useCallback(() => {
    audioService.stopCurrentAudio();
    audioPlaying.value = false;
  }, []);

  return {
    playAudio,
    stopAudio,
    isPlaying: audioPlaying.value,
    isLoading: audioLoading.value,
    isAvailable: audioService.isAvailable()
  };
}
